import {
  GET_CLIENTS_REQUESTED,
  GET_CLIENTS_SUCCESS,
  CLIENTS_FAILED,
  PUT_COMPOSEPROFILES_REQUESTED,
  PUT_COMPOSEPROFILES_SUCCESS,
  PUT_COMPOSEPROFILES_FAILED,
  CLIENTS_RESET,
  PRINT_CLIENT_PROFILE,
  PRINT_CLIENT_PROFILE_FAILED, GET_FULL_NAME_REQUESTED, GET_FULL_NAME_SUCCESS, GET_DEAL_NUMBER, GET_DEAL_NUMBER_SUCCESS,
} from './actionTypes'

export const getFullNameDeal = payload => ({
    type: GET_FULL_NAME_REQUESTED,
    payload
})

export const getFullNameDealSuccess = payload => ({
  type: GET_FULL_NAME_SUCCESS,
  payload
})

export const getDealNumber = payload => ({
  type: GET_DEAL_NUMBER,
  payload
})

export const getDealNumberSuccess = payload => ({
  type: GET_DEAL_NUMBER_SUCCESS,
  payload
})
export const getClients = payload => ({
  type: GET_CLIENTS_REQUESTED,
  payload
})

export const getClientsSuccess = payload => ({
  type: GET_CLIENTS_SUCCESS,
  payload
})

export const clientsFailed = payload => ({
  type: CLIENTS_FAILED,
  payload
})

export const composeProfiles = payload => ({
  type: PUT_COMPOSEPROFILES_REQUESTED,
  payload
})

export const composeProfilesSuccess = payload => ({
  type: PUT_COMPOSEPROFILES_SUCCESS,
  payload
})

export const composeProfilesFailed = payload => ({
  type: PUT_COMPOSEPROFILES_FAILED,
  payload
})

export const printClientInfo = ( client, reportType ) => ({
  type: PRINT_CLIENT_PROFILE, 
  payload: { client, reportType }
})

export const printClientInfoFailed = payload => ({
  type: PRINT_CLIENT_PROFILE_FAILED,
  payload
})

export const resetClients = () => ({ type: CLIENTS_RESET })
